/** Given a layer key, return all the general layers for that layer key */

import { LayerKey, resolveTopologicalPath } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useMetaModelContext } from '../../../context/metaModelContext'

export const useGeneralLayers = (layer: Optional<LayerKey>) => {
  const { layerTopology } = useMetaModelContext()

  return useMemo(() => {
    if (!layer?.layerId && !layer?.tenantId) {
      return []
    }

    if (layer.layerId) {
      return resolveTopologicalPath(layer, layerTopology).slice(0, -1)
    }

    // Only a tenantId is provided, return the general layers for the tenant
    // If no layer is provided lower layers will always be the ones with no tenant and no layer name
    return [new LayerKey({ layerId: null, tenantId: null })]
  }, [layer, layerTopology])
}
